module.exports = __webpack_public_path__ + "static/business-climate-7056b9939ed69d0d7d9d88fecce5fa92.jpg";